export const ErrorSeverityEnum = {
  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success"
};
